var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeepthink(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "atom-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M13.7367 12.4479C13.5382 12.6724 13.3298 12.8941 13.1119 13.1119C9.96103 16.2629 6.01344 17.4239 4.29476 15.7052C3.11647 14.527 3.2917 12.3011 4.5337 10.0025M6.23629 7.58268C6.44292 7.34774 6.66029 7.11581 6.88805 6.88805C10.039 3.73713 13.9866 2.57608 15.7052 4.29476C16.8843 5.47386 16.7081 7.70202 15.4637 10.0023M13.1119 6.88805C16.2629 10.039 17.4239 13.9866 15.7052 15.7052C13.9866 17.4239 10.039 16.2629 6.88805 13.1119C3.73713 9.96103 2.57608 6.01344 4.29476 4.29476C6.01344 2.57608 9.96103 3.73713 13.1119 6.88805ZM10.7182 9.98468C10.7182 10.3898 10.3898 10.7182 9.98473 10.7182C9.57963 10.7182 9.25124 10.3898 9.25124 9.98468C9.25124 9.57958 9.57963 9.25119 9.98473 9.25119C10.3898 9.25119 10.7182 9.57958 10.7182 9.98468Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeepthink);
export default __webpack_public_path__ + "static/media/deepthink.50977a6aebae59ec36d2f2a60dd829ba.svg";
export { ForwardRef as ReactComponent };